<script>
    import { getContext } from 'svelte';

    export let model_root;
    export let currentMenuItemData;
    export let footer;

    const { close } = getContext('simple-modal');

    const maxMenuNameLength = 28;

    $ : moduleName = currentMenuItemData.mname;
    $ : menuNameLength = moduleName.length;

    let errorMsg = "";
    let successMsg = "";

    function uploadNewMenuItem() {
        const data = new FormData();
        data.append("mname", moduleName);
        if(footer == 1) {
            data.append("footer", 1);
        } else {
            data.append("footer", 0);
        }
        if(currentMenuItemData.mparent !== undefined) {
            data.append("mparent", currentMenuItemData.mparent);
        }

        fetch(model_root + 'admin/menu/add_menu_item.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if(msg === "success") {
                    showSuccessMsg("Menüpunkt wurde erfolgreich erstellt! Das Fenster schließt sich automatisch.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function updateMenuItem() {
        const data = new FormData();
        data.append("mid", currentMenuItemData.mid);
        data.append("mname", moduleName);

        fetch(model_root + 'admin/menu/update_menu_item.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if(msg === "success") {
                    showSuccessMsg("Menüpunkt wurde erfolgreich aktualisiert! Das Fenster schließt sich automatisch.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function hideMenuTool() {
        close();
    }

    function showSuccessMsg(msg) {
        errorMsg = "";
        successMsg = msg;
        setTimeout(hideMenuTool, 3200);
    }

    function showErrorMsg(msg) {
        errorMsg = msg;
    }
</script>

<div class="row mt-2 mb-1">
    <form
            on:submit|preventDefault={ () => {
                currentMenuItemData.mname.length === 0 ? uploadNewMenuItem() : updateMenuItem();
            } }
            on:reset|preventDefault={hideMenuTool}>

        <div class="mb-3">
            <label for="mname" class="form-label">Name des Menüpunktes:</label>
            <input
                    value={moduleName} on:input={e => moduleName = e.target.value}
                    type="text"
                    maxlength={maxMenuNameLength}
                    id="mname"
                    class:is-invalid="{menuNameLength === 0}"
                    class:is-valid="{menuNameLength > 0}"
                    class="form-control">
            <div id="emailHelp" class="form-text">Geben Sie hier den Namen des Menüpunktes an. Die Wortlänge ist auf {maxMenuNameLength} Zeichen begrenzt.</div>
        </div>

        {#if errorMsg.length > 0}
            <div class="alert alert-danger" role="alert">
                {errorMsg}
            </div>
        {/if}
        {#if successMsg.length > 0}
            <div class="alert alert-success" role="alert">
                <i class="fas fa-circle-notch fa-spin"></i>
                {successMsg}
            </div>
        {/if}

        {#if successMsg.length === 0}
            {#if currentMenuItemData.mname.length === 0}
                <button type="submit" class="btn btn-primary">Hinzufügen</button>
            {:else}
                <button type="submit" class="btn btn-primary">Ändern</button>
            {/if}
            <button type="reset" class="btn btn-secondary">Abbrechen</button>
        {/if}
    </form>
</div>

<style>

</style>